module.exports = __webpack_public_path__ + "static/john-ortberg-0579ec63231786e09cdc2844bba6e9dc.png";